import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Navbar from "../../components/Navbar";
import {
  Container,
  Grid,
  Stack,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  RadioGroup,
  FormControlLabel,
  Radio,
  Typography,
  Snackbar,
  Alert,
  InputAdornment,
  CircularProgress,
  Autocomplete,
} from "@mui/material";
import FmdGoodOutlinedIcon from "@mui/icons-material/FmdGoodOutlined";
import PageHeader from "../../components/PageHeader";
import DoneIcon from "@mui/icons-material/Done";
import UserInfoBanner from "../../assets/Images/UserInfoBanner.png";
import ImageUploader from "../../components/ImageUploader";
import { styled } from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import {
  serviceProviderInfo,
  createStripeConnectAccount,
  getAllCategories,
} from "../../apis";
import usePlacesAutocomplete, {
  getGeocode,
  getLatLng,
} from "use-places-autocomplete";
import { useNavigate } from "react-router-dom";
const ListItem = styled("li")(({ theme }) => ({
  margin: theme.spacing(0.5),
}));

const ServiceProvider = () => {
  const user = JSON.parse(localStorage.getItem("user-info"));
  const userName = user.fullName;
  const userID = user?.googleId ? user.googleId : user._id;

  const {
    ready,
    value,
    suggestions: { status, data },
    setValue,
    clearSuggestions,
  } = usePlacesAutocomplete({
    requestOptions: {
      /* Define search scope here */
    },
    debounce: 300,
  });

  const [openSnack, setOpenSnack] = useState(false);
  const [address, setAddress] = useState("");
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [buttonLoading, setButtonLoading] = useState(false);

  const [stage, setStage] = useState(1);

  const childDataHandler = (data) => {
    setImages(data);
  };

  const certificatioChildDataHandler = (data) => {
    setCertificationImages(data);
  };
  const photoIDChildDataHandler = (data) => {
    setPhotoIDImages(data);
  };
  const pofChildDataHandler = (data) => {
    setPofImages(data);
  };

  // Personal Information States
  const [accountType, setAccountType] = useState("Personal");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [description, setDescription] = useState("");
  const [jobTitle, setJobTitle] = useState("");
  const [images, setImages] = useState([]);
  const [traderName, setTraderName] = useState("");
  const [VATNumber, setVATNumber] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [companyRegistrationNumber, setCompanyRegistrationNumber] =
    useState("");
  // Personal Information States

  // Skills and expertise states
  const [category, setCategory] = useState("");
  const [subCategory, setSubCategory] = useState("");
  const [skills, setSkills] = useState([
    { key: 0, label: "AC Management" },
    { key: 1, label: "AC Installation" },
    { key: 2, label: "Dispenser Fixing" },
    { key: 3, label: "General Services" },
    { key: 4, label: "AC Management" },
    { key: 5, label: "AC Installation" },
    { key: 6, label: "Dispenser Fixing" },
    { key: 7, label: "General Services" },
  ]);
  const [mySkill, setMySkill] = useState("");
  const [categoriesData, setCategoriesData] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  // Skills and expertise states

  // Certifications states
  const [certificationData, setCertificationData] = useState([
    {
      certificationName: "",
      startDate: "",
      endDate: "",
      institutionName: "",
      certificationImages: [],
    },
  ]);
  const [certificationName, setCertificationName] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [institutionName, setInstitutionName] = useState("");
  const [certificationImages, setCertificationImages] = useState([]);
  const [photoIDImages, setPhotoIDImages] = useState([]);
  const [pofImages, setPofImages] = useState([]);
  // Certifications states

  // Payment Information States
  const [cardHolderName, setCardHolderName] = useState("");
  const [cardNumber, setCardNumber] = useState("");
  const [expiryDate, setExpiryDate] = useState(null);
  const [securityCode, setSecurityCode] = useState("");
  const [country, setCountry] = useState("");
  const [city, setCity] = useState("");
  const [doorNumber, setDoorNumber] = useState("");
  const [streetAddress, setStreetAddress] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("card");

  // Payment Information States

  const navigate = useNavigate();

  useEffect(() => {
    setMySkill("");
  }, [skills]);
  const handleDelete = (chipToDelete) => () => {
    setSkills((chips) => chips.filter((chip) => chip.key !== chipToDelete.key));
  };
  const handleChange = (event) => {
    setCategory(event.target.value);
    const filtereddata = categoriesData.filter(
      (item) => item.name == event.target.value
    );
    setSubCategories(filtereddata[0].subCategories);
  };
  const handlePaymentMethod = (event) => {
    setPaymentMethod(event.target.value);
  };

  const handleChangeSubCategory = (event) => {
    setSubCategory(event.target.value);
  };

  useEffect(() => {
    const fetchData = async () => {
      const response = await getAllCategories();
      setCategoriesData(response.data.categories);
      let arr = [];
      response.data.categories.map((item) => {
        arr.push({ label: item.name, value: item.name });
      });
      setCategories(arr);
    };
    const user = JSON.parse(localStorage.getItem("user-info"));
    setFirstName(user.firstName);
    setLastName(user.lastName);
    setEmail(user.email);
    fetchData();
  }, []);

  const submitServiceProviderInfo = async () => {
    const personalInfo = {
      accountType: accountType,
      firstName: firstName,
      lastName: lastName,
      image: images,
      phoneNumber: phoneNumber,
      email: email,
      description: description,
      jobTitle: jobTitle,
      traderName: traderName,
      VATNumber: VATNumber,
      companyName: companyName,
      companyRegistrationNumber: companyRegistrationNumber,
    };

    const expertise = {
      category: category,
      subCategory: subCategory,
      skills: skills,
    };

    const documents = {
      certificationName: certificationName,
      startDate: startDate,
      endDate: endDate,
      institutionName: institutionName,
      certificationImages: certificationImages,
      pofImages: pofImages,
      photoID: photoIDImages,
    };

    const paymentDetails = {
      cardHolderName: cardHolderName,
      cardNumber: cardNumber,
      paymentMethod: paymentMethod,
      securityCode: securityCode,
      expiryDate: expiryDate,
      country: country,
      city: city,
      doorNumber: doorNumber,
      streetAddress: streetAddress,
      postalCode: postalCode,
    };

    if (
      cardHolderName != "" &&
      cardNumber != "" &&
      securityCode != "" &&
      country != "" &&
      city != "" &&
      doorNumber != "" &&
      streetAddress != "" &&
      postalCode != "" &&
      expiryDate != null
    ) {
      const data = await serviceProviderInfo({
        serviceProviderId: userID,
        personalInfo: personalInfo,
        expertise: expertise,
        documents: documents,
        paymentDetails: paymentDetails,
      });
      if (data) {
        let user = JSON.parse(localStorage.getItem("user-info"));
        user.infoFilled = true;
        localStorage.setItem("user-info", JSON.stringify(user));
        navigate("/service-provider/under-review");
      }
    }
  };

  const secondStageHandler = () => {
    if (accountType == "Personal") {
      if (
        firstName != "" &&
        lastName != "" &&
        images.length != 0 &&
        phoneNumber != "" &&
        email != "" &&
        jobTitle != "" &&
        description != "" &&
        address != "" &&
        longitude != "" &&
        latitude != ""
      ) {
        setStage(3);
      } else {
        setOpenSnack(true);
      }
    }
    if (accountType == "Sole Trader") {
      if (
        firstName != "" &&
        lastName != "" &&
        images.length != 0 &&
        phoneNumber != "" &&
        email != "" &&
        jobTitle != "" &&
        description != "" &&
        traderName != "" &&
        address != "" &&
        longitude != "" &&
        latitude != ""
      ) {
        setStage(3);
      } else {
        setOpenSnack(true);
      }
    }
    if (accountType == "Company") {
      if (
        firstName != "" &&
        lastName != "" &&
        images.length != 0 &&
        phoneNumber != "" &&
        email != "" &&
        jobTitle != "" &&
        description != "" &&
        companyName != "" &&
        companyRegistrationNumber != "" &&
        address != "" &&
        longitude != "" &&
        latitude != ""
      ) {
        setStage(3);
      } else {
        setOpenSnack(true);
      }
    }
  };

  const thirdStageHandler = () => {
    if (skills.length != 0 && category != "" && subCategory != "") {
      setStage(4);
    } else {
      setOpenSnack(true);
    }
  };

  const fourthStageHandler = async () => {
    let checkEmpty = false;
    certificationData.map((item) => {
      checkEmpty = Object.values(item).some((x) => x == "");
    });
    if (!checkEmpty && photoIDImages.length != 0 && pofImages.length != 0) {
      setButtonLoading(true);
      const personalInfo = {
        accountType: accountType,
        avgRating: 0,
        firstName: firstName,
        lastName: lastName,
        image: images,
        phoneNumber: phoneNumber,
        email: email,
        description: description,
        jobTitle: jobTitle,
        traderName: traderName,
        VATNumber: VATNumber,
        companyName: companyName,
        companyRegistrationNumber: companyRegistrationNumber,
        address: address,
        longitude: longitude,
        latitude: latitude,
      };

      const expertise = {
        category: category,
        subCategory: subCategory,
        skills: skills,
      };

      const documents = {
        certificationData: certificationData,
        pofImages: pofImages,
        photoID: photoIDImages,
      };

      const info = { personalInfo, expertise, documents };
      localStorage.setItem("info", JSON.stringify(info));
      const reponse = await createStripeConnectAccount({ email: email });
      if (reponse.data.success) {
        window.location.href = reponse.data.accountLink.url;
      }
      setButtonLoading(false);
      // setStage(5);
    } else {
      setOpenSnack(true);
    }
  };

  const handleClose = () => {
    setOpenSnack(false);
  };

  const certifications = [
    {
      value: "Federation of Master Builders",
      label: "Federation of Master Builders",
    },
    {
      value: "Guild of Builders and Contractors",
      label: "Guild of Builders and Contractors",
    },
    {
      value: "Stone Federation Great Britain",
      label: "Stone Federation Great Britain",
    },
    {
      value: "Guild of Master Craftsmen",
      label: "Guild of Master Craftsmen",
    },
    {
      value: "British Woodworking Federation",
      label: "British Woodworking Federation",
    },
    {
      value: "Association of Master Upholsterers & Soft Furnishers",
      label: "Association of Master Upholsterers & Soft Furnishers",
    },
    {
      value: "National Carpet Cleaners Association",
      label: "National Carpet Cleaners Association",
    },
    {
      value: "National Institute of Carpet & Floorlayers",
      label: "National Institute of Carpet & Floorlayers",
    },
    {
      value: "The British Board of Agrément Solid Wall Insulation",
      label: "The British Board of Agrément Solid Wall Insulation",
    },
    {
      value: "The Cavity Wall Insulation Self Certification scheme",
      label: "The Cavity Wall Insulation Self Certification scheme",
    },
    {
      value: "Gas Safe Register",
      label: "Gas Safe Register",
    },
    {
      value: "National Association of Chimney Engineers",
      label: "National Association of Chimney Engineers",
    },
    {
      value: "National Association of Chimney Sweeps",
      label: "National Association of Chimney Sweeps",
    },
    {
      value: "Blue Flame Certification",
      label: "Blue Flame Certification",
    },
    {
      value: "ELECSA",
      label: "ELECSA",
    },
    {
      value: "NAPIT",
      label: "NAPIT",
    },
    {
      value: "National Inspection Council for Electrical Installation",
      label: "National Inspection Council for Electrical Installation",
    },
    {
      value: "Association of Fencing Industries",
      label: "Association of Fencing Industries",
    },
    {
      value: "BAFE",
      label: "BAFE",
    },
    {
      value: "Contract Flooring Association",
      label: "Contract Flooring Association",
    },
    {
      value: "CHAS",
      label: "CHAS",
    },
    {
      value: "Constructionline",
      label: "Constructionline",
    },
    {
      value: "SafeContractor",
      label: "SafeContractor",
    },
    {
      value: "HETAS",
      label: "HETAS",
    },
    {
      value: "BALI",
      label: "BALI",
    },
    {
      value: "Master Locksmith Association",
      label: "Master Locksmith Association",
    },
    {
      value: "Painting and Decorating Association",
      label: "Painting and Decorating Association",
    },
    {
      value: "British Pest Control Association",
      label: "British Pest Control Association",
    },
    {
      value: "NPTA",
      label: "NPTA",
    },
    {
      value: "Finishes and Interiors Sector",
      label: "Finishes and Interiors Sector",
    },
    {
      value: "Association of Plumbing and Heating Contractors",
      label: "Association of Plumbing and Heating Contractors",
    },
    {
      value: "Building Engineering Services Competence Assessment Limited",
      label: "Building Engineering Services Competence Assessment Limited",
    },
    {
      value: "Chartered Institute of Plumbing and Heating Engineers",
      label: "Chartered Institute of Plumbing and Heating Engineers",
    },
    {
      value: "Oil Firing Technical Association Limited",
      label: "Oil Firing Technical Association Limited",
    },
    {
      value: "Solar Trade Association",
      label: "Solar Trade Association",
    },
    {
      value: "National Federation of Roofing Contractors",
      label: "National Federation of Roofing Contractors",
    },
    {
      value: "National Access & Scaffolding Confederation",
      label: "National Access & Scaffolding Confederation",
    },
    {
      value: "The National Security Inspectorate",
      label: "The National Security Inspectorate",
    },
    {
      value: "Confederation of Aerial Industries",
      label: "Confederation of Aerial Industries",
    },
    {
      value: "Assure Certification Ltd",
      label: "Assure Certification Ltd",
    },
    {
      value: "CERTASS Limited",
      label: "CERTASS Limited",
    },
    {
      value: "Exova BM TRADA Competent Persons Scheme",
      label: "Exova BM TRADA Competent Persons Scheme",
    },
    {
      value: "FENSA",
      label: "FENSA",
    },
    {
      value: "Glass and Glazing Federation",
      label: "Glass and Glazing Federation",
    },
  ];

  const addCertificateHandler = () => {
    let checkEmpty = false;
    certificationData.map((item) => {
      checkEmpty = Object.values(item).some((x) => x == "");
    });
    if (!checkEmpty) {
      setCertificationData([
        ...certificationData,
        {
          certificationName: "",
          startDate: "",
          endDate: "",
          institutionName: "",
          certificationImages: [],
        },
      ]);
    }
  };

  let removeFormFields = (i) => {
    let newCertificationData = [...certificationData];
    if (newCertificationData.length > 1) {
      newCertificationData.splice(i, 1);
      setCertificationData(newCertificationData);
    }
  };

  const handleCertificationChange = (i, name, value) => {
    let newCertificationData = [...certificationData];
    newCertificationData[i][name] = value;
    setCertificationData(newCertificationData);
  };

  const handleSelect =
    ({ description }) =>
    () => {
      // When user selects a place, we can replace the keyword without request data from API
      // by setting the second parameter to "false"
      setValue(description, false);
      setAddress(description);
      clearSuggestions();

      // Get latitude and longitude via utility functions
      getGeocode({ address: description }).then((results) => {
        const { lat, lng } = getLatLng(results[0]);
        console.log("📍 Coordinates: ", { lat, lng });
        setLatitude(lat);
        setLongitude(lng);
      });
    };

  const renderSuggestions = () =>
    data.map((suggestion) => {
      const {
        place_id,
        structured_formatting: { main_text, secondary_text },
      } = suggestion;

      return (
        // <li key={place_id} onClick={handleSelect(suggestion)}>
        //   <strong>{main_text}</strong> <small>{secondary_text}</small>
        // </li>
        <div
          style={{
            padding: "10px",
            borderBottom: "1px solid #EEEBEF",
            cursor: "pointer",
          }}
          onClick={handleSelect(suggestion)}
        >
          <Typography>
            {main_text}, {secondary_text}
          </Typography>
        </div>
      );
    });

  return (
    <>
      <PageHeader title="Register as Partner" crossIcon />
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={openSnack}
        autoHideDuration={2000}
        onClose={handleClose}
      >
        <Alert
          severity="error"
          sx={{ width: "100%" }}
          variant="filled"
          onClose={handleClose}
        >
          Please fill all of the required information in order to proceed!
        </Alert>
      </Snackbar>
      <Container>
        <Grid container>
          {/* Stepper Start */}
          <Grid item xs={3}>
            <Stack spacing={3}>
              {stage == 1 ? (
                <Stack direction="row" spacing={1} alignItems="center">
                  <div className="currentStageContainer">
                    <span className="currentStageText">1</span>
                  </div>
                  <Typography variant="subtitle2" gutterBottom component="div">
                    Getting Started
                  </Typography>
                </Stack>
              ) : (
                <Stack direction="row" spacing={1} alignItems="center">
                  <div className="currentStageContainer">
                    <span className="crossIcon">
                      <DoneIcon className="previousStageColor" />
                    </span>
                  </div>
                  <Typography
                    variant="subtitle2"
                    gutterBottom
                    component="div"
                    className="previousStageColor"
                  >
                    Getting Started
                  </Typography>
                </Stack>
              )}

              {stage == 2 ? (
                <Stack direction="row" spacing={1} alignItems="center">
                  <div className="currentStageContainer">
                    <span className="currentStageText">2</span>
                  </div>
                  <Typography variant="subtitle2" gutterBottom component="div">
                    Personal Details
                  </Typography>
                </Stack>
              ) : stage < 2 ? (
                <Stack direction="row" spacing={1} alignItems="center">
                  <div className="currentStageContainer">
                    <span className="nextStageColor">2</span>
                  </div>
                  <Typography
                    variant="subtitle2"
                    className="nextStageColor"
                    gutterBottom
                    component="div"
                  >
                    Personal Details
                  </Typography>
                </Stack>
              ) : (
                <Stack direction="row" spacing={1} alignItems="center">
                  <div className="currentStageContainer">
                    <span className="crossIcon">
                      <DoneIcon className="previousStageColor" />
                    </span>
                  </div>
                  <Typography
                    variant="subtitle2"
                    gutterBottom
                    component="div"
                    className="previousStageColor"
                  >
                    Personal Details
                  </Typography>
                </Stack>
              )}

              {stage == 3 ? (
                <Stack direction="row" spacing={1} alignItems="center">
                  <div className="currentStageContainer">
                    <span className="currentStageText">3</span>
                  </div>
                  <Typography variant="subtitle2" gutterBottom component="div">
                    Skilss and Expertise
                  </Typography>
                </Stack>
              ) : stage < 3 ? (
                <Stack direction="row" spacing={1} alignItems="center">
                  <div className="currentStageContainer">
                    <span className="nextStageColor">3</span>
                  </div>
                  <Typography
                    variant="subtitle2"
                    className="nextStageColor"
                    gutterBottom
                    component="div"
                  >
                    Skilss and Expertise
                  </Typography>
                </Stack>
              ) : (
                <Stack direction="row" spacing={1} alignItems="center">
                  <div className="currentStageContainer">
                    <span className="crossIcon">
                      <DoneIcon className="previousStageColor" />
                    </span>
                  </div>
                  <Typography
                    variant="subtitle2"
                    gutterBottom
                    component="div"
                    className="previousStageColor"
                  >
                    Skilss and Expertise
                  </Typography>
                </Stack>
              )}

              {stage == 4 ? (
                <Stack direction="row" spacing={1} alignItems="center">
                  <div className="currentStageContainer">
                    <span className="currentStageText">4</span>
                  </div>
                  <Typography variant="subtitle2" gutterBottom component="div">
                    Documents
                  </Typography>
                </Stack>
              ) : stage < 4 ? (
                <Stack direction="row" spacing={1} alignItems="center">
                  <div className="currentStageContainer">
                    <span className="nextStageColor">4</span>
                  </div>
                  <Typography
                    variant="subtitle2"
                    className="nextStageColor"
                    gutterBottom
                    component="div"
                  >
                    Documents
                  </Typography>
                </Stack>
              ) : (
                <Stack direction="row" spacing={1} alignItems="center">
                  <div className="currentStageContainer">
                    <span className="crossIcon">
                      <DoneIcon className="previousStageColor" />
                    </span>
                  </div>
                  <Typography
                    variant="subtitle2"
                    gutterBottom
                    component="div"
                    className="previousStageColor"
                  >
                    Documents
                  </Typography>
                </Stack>
              )}

              {stage == 5 ? (
                <Stack direction="row" spacing={1} alignItems="center">
                  <div className="currentStageContainer">
                    <span className="currentStageText">5</span>
                  </div>
                  <Typography variant="subtitle2" gutterBottom component="div">
                    Payment Information
                  </Typography>
                </Stack>
              ) : stage < 5 ? (
                <Stack direction="row" spacing={1} alignItems="center">
                  <div className="currentStageContainer">
                    <span className="nextStageColor">5</span>
                  </div>
                  <Typography
                    variant="subtitle2"
                    className="nextStageColor"
                    gutterBottom
                    component="div"
                  >
                    Payment Information
                  </Typography>
                </Stack>
              ) : (
                <Stack direction="row" spacing={1} alignItems="center">
                  <div className="currentStageContainer">
                    <span className="crossIcon">
                      <DoneIcon className="previousStageColor" />
                    </span>
                  </div>
                  <Typography
                    variant="subtitle2"
                    gutterBottom
                    component="div"
                    className="previousStageColor"
                  >
                    Payment Information
                  </Typography>
                </Stack>
              )}
            </Stack>
          </Grid>

          {/* Stepper End */}

          <Grid item xs={6}>
            {stage == 1 ? (
              <Box component="div" sx={{ p: 2 }}>
                <img src={UserInfoBanner} />
                <Stack className="mt-16">
                  <Stack>
                    <Typography variant="h4" gutterBottom component="div">
                      Join Amannat as a Service Provider
                    </Typography>
                  </Stack>
                  <Stack>
                    <Typography variant="body1" gutterBottom>
                      Hi {userName.toUpperCase()}
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      Thank you for showing your interest to join Amaanat
                      platform. We are helping professionals like you to promote
                      their digital presence.
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                      Heres how it works:
                    </Typography>
                    <ol>
                      <li>Complete your profile accurately</li>
                      <li>Submit your profile</li>
                      <li>
                        You'll receive an email to let you know if your profile
                        got approved.
                      </li>
                    </ol>
                    <Typography variant="body1" gutterBottom>
                      Our team will be looking forward.
                    </Typography>
                  </Stack>
                </Stack>

                <Stack
                  direction="row"
                  className="mt-13"
                  justifyContent="space-between"
                >
                  <Button
                    variant="outlined"
                    style={{ textTransform: "capitalize" }}
                    onClick={() => navigate("/")}
                    className="default-color default-border"
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    style={{ textTransform: "capitalize" }}
                    onClick={() => setStage(2)}
                    className="primary-button"
                  >
                    Continue
                  </Button>
                </Stack>
              </Box>
            ) : stage == 2 ? (
              <Box>
                <Stack spacing={3} direction="column">
                  <h2 className="mt-13">Personal Information</h2>
                  <Typography className="registration-label">
                    Type of Account
                  </Typography>
                  <FormControl>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                    >
                      <FormControlLabel
                        className={
                          accountType == "Personal"
                            ? "activeRadioContainer"
                            : "radioContainer"
                        }
                        value="Personal"
                        control={<Radio />}
                        label="Personal"
                        checked={accountType == "Personal" ? true : false}
                        onClick={() => setAccountType("Personal")}
                      />
                      <FormControlLabel
                        className={
                          accountType == "Sole Trader"
                            ? "activeRadioContainer"
                            : "radioContainer"
                        }
                        value="Sole Trader"
                        control={<Radio />}
                        label="Sole Trader"
                        checked={accountType == "Sole Trader" ? true : false}
                        onClick={() => setAccountType("Sole Trader")}
                      />
                      <FormControlLabel
                        className={
                          accountType == "Company"
                            ? "activeRadioContainer"
                            : "radioContainer"
                        }
                        value="Company"
                        control={<Radio />}
                        label="Company"
                        checked={accountType == "Company" ? true : false}
                        onClick={() => setAccountType("Company")}
                      />
                    </RadioGroup>
                  </FormControl>
                  {accountType == "Personal" ? (
                    <></>
                  ) : accountType == "Sole Trader" ? (
                    <Stack direction="row" spacing={2}>
                      <Stack className="w-100">
                        <Typography className="registration-label">
                          Trader Name
                        </Typography>
                        <TextField
                          required
                          id="outlined-basic"
                          variant="outlined"
                          className="w-100"
                          size="small"
                          placeholder="Enter trader name"
                          value={traderName}
                          onChange={(e) => setTraderName(e.target.value)}
                        />
                      </Stack>
                      <Stack className="w-100">
                        <Typography className="registration-label">
                          VAT Number (Optional)
                        </Typography>
                        <TextField
                          required
                          id="outlined-basic"
                          variant="outlined"
                          className="w-100"
                          size="small"
                          placeholder="Enter VAT number"
                          value={VATNumber}
                          onChange={(e) => setVATNumber(e.target.value)}
                        />
                      </Stack>
                    </Stack>
                  ) : (
                    <>
                      <Stack direction="row" spacing={2}>
                        <Stack className="w-100">
                          <Typography className="registration-label">
                            Company Name
                          </Typography>
                          <TextField
                            required
                            id="outlined-basic"
                            variant="outlined"
                            className="w-100"
                            size="small"
                            placeholder="Enter company name"
                            value={companyName}
                            onChange={(e) => setCompanyName(e.target.value)}
                          />
                        </Stack>
                        <Stack className="w-100">
                          <Typography className="registration-label">
                            Company Registration Number
                          </Typography>
                          <TextField
                            required
                            id="outlined-basic"
                            variant="outlined"
                            className="w-100"
                            size="small"
                            placeholder="Enter registration number"
                            value={companyRegistrationNumber}
                            onChange={(e) =>
                              setCompanyRegistrationNumber(e.target.value)
                            }
                          />
                        </Stack>
                      </Stack>
                      <Stack className="w-50">
                        <Typography className="registration-label">
                          VAT Number(Optional)
                        </Typography>
                        <TextField
                          required
                          id="outlined-basic"
                          variant="outlined"
                          className="w-100"
                          size="small"
                          placeholder="Enter VAT number"
                          value={VATNumber}
                          onChange={(e) => setVATNumber(e.target.value)}
                        />
                      </Stack>
                    </>
                  )}
                  <Stack direction="row" spacing={2}>
                    <Stack className="w-100 ">
                      <Typography className="registration-label">
                        First Name
                      </Typography>
                      <TextField
                        required
                        id="outlined-basic"
                        variant="outlined"
                        className="w-100 "
                        size="small"
                        placeholder="Enter your First Name"
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                      />
                    </Stack>
                    <Stack className="w-100 ">
                      <Typography className="registration-label">
                        Last Name
                      </Typography>
                      <TextField
                        required
                        id="outlined-basic"
                        variant="outlined"
                        className="w-100 "
                        size="small"
                        placeholder="Enter your Last Name"
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                      />
                    </Stack>
                  </Stack>

                  <Stack>
                    <ImageUploader
                      passChildData={childDataHandler}
                      heading="Upload Profile Picture (Please upload professional picture which shows your face)"
                      title="Upload your picture here"
                      profileImage
                    />
                  </Stack>

                  <Stack direction="row" spacing={2}>
                    <Stack className="w-100 ">
                      <Typography className="registration-label">
                        Phone Number
                      </Typography>
                      <TextField
                        required
                        id="outlined-basic"
                        variant="outlined"
                        className="w-100 "
                        size="small"
                        placeholder="Enter your phone number"
                        value={phoneNumber}
                        onChange={(e) => setPhoneNumber(e.target.value)}
                      />
                    </Stack>
                    <Stack className="w-100 ">
                      <Typography className="registration-label">
                        Email Address
                      </Typography>
                      <TextField
                        required
                        id="outlined-basic"
                        variant="outlined"
                        className="w-100 "
                        size="small"
                        placeholder="Enter your email address"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </Stack>
                  </Stack>
                  <Stack>
                    <Typography className="ammanat-darker-gray">
                      Address
                    </Typography>
                    <TextField
                      required
                      size="small"
                      variant="outlined"
                      className="w-100"
                      placeholder="Enter your address"
                      value={value}
                      disabled={!ready}
                      onChange={(e) => {
                        setAddress(e.target.value);
                        setValue(e.target.value);
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <FmdGoodOutlinedIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Stack>
                  <Stack>
                    {/* We can use the "status" to decide whether we should display the dropdown or not */}
                    {status === "OK" && (
                      <div
                        style={{
                          border: "1px solid #EEEBEF",
                          borderRadius: "6px",
                          background: "white",
                          position: "absolute",
                          zIndex: "100",
                          width: "47%",
                        }}
                        className="mb-16"
                      >
                        {renderSuggestions()}
                      </div>
                    )}
                  </Stack>
                  <Stack>
                    <Typography className="registration-label">
                      Job Title
                    </Typography>
                    <TextField
                      required
                      id="outlined-basic"
                      variant="outlined"
                      className="w-100 "
                      size="small"
                      placeholder="Enter your current occupation"
                      value={jobTitle}
                      onChange={(e) => setJobTitle(e.target.value)}
                    />
                  </Stack>

                  <Stack>
                    <Typography className="registration-label">
                      About you
                    </Typography>
                    <TextField
                      required
                      id="outlined-basic"
                      variant="outlined"
                      className="w-100 "
                      multiline
                      rows={3}
                      placeholder="Enter some descriptionn about you"
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                    />
                  </Stack>
                  <div className="d-flex space-between mb-10">
                    <Button
                      variant="outlined"
                      type="submit"
                      className="mt-13  default-border default-color"
                      onClick={() => setStage(1)}
                      style={{ textTransform: "capitalize" }}
                    >
                      Back
                    </Button>

                    <Button
                      variant="contained"
                      className="mt-13 primary-button"
                      onClick={secondStageHandler}
                      style={{ textTransform: "capitalize" }}
                    >
                      Next
                    </Button>
                  </div>
                </Stack>
              </Box>
            ) : stage == 3 ? (
              <Box>
                <Stack spacing={3} direction="column">
                  <h2 className="mt-13">Skills & Expertise</h2>

                  <Stack direction="row" spacing={2}>
                    <FormControl fullWidth size="small">
                      <Typography
                        id="demo-simple-select-label"
                        className="registration-label"
                      >
                        Select Category
                      </Typography>
                      <Select
                        displayEmpty
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={category}
                        onChange={handleChange}
                      >
                        <MenuItem disabled value="">
                          <em>Select Category</em>
                        </MenuItem>
                        {categories.map((item) => (
                          <MenuItem value={item.value}>{item.label}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <FormControl fullWidth size="small">
                      <Typography
                        id="demo-simple-select-label"
                        className="registration-label"
                      >
                        Select Sub Category
                      </Typography>
                      <Select
                        displayEmpty
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={subCategory}
                        onChange={handleChangeSubCategory}
                      >
                        <MenuItem disabled value="">
                          <em>Select Sub Category</em>
                        </MenuItem>
                        {subCategories.map((item) => (
                          <MenuItem value={item.value}>{item.label}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Stack>
                  <Stack>
                    <Typography
                      variant="subtitle2"
                      gutterBottom
                      component="div"
                      className="registration-label"
                    >
                      Select Skills
                    </Typography>
                    <Paper
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        flexWrap: "wrap",
                        listStyle: "none",
                        p: 0.5,
                        m: 0,
                      }}
                      component="ul"
                    >
                      {skills.map((data) => {
                        return (
                          <ListItem key={data.key}>
                            <Chip
                              label={data.label}
                              onDelete={handleDelete(data)}
                            />
                          </ListItem>
                        );
                      })}
                    </Paper>
                  </Stack>
                  <Stack>
                    <Typography className="registration-label">
                      Enter additional skillset
                    </Typography>
                    <TextField
                      required
                      id="outlined-basic"
                      variant="outlined"
                      className="w-100 "
                      size="small"
                      value={mySkill}
                      onChange={(e) => setMySkill(e.target.value)}
                      onKeyPress={(e) => {
                        if (e.key === "Enter") {
                          let obj = {
                            key:
                              skills.length > 0
                                ? skills[skills.length - 1].key + 1
                                : 1,
                            label: mySkill,
                          };
                          setSkills((previous) => [...previous, obj]);
                        }
                      }}
                      placeholder="Enter your other skills here"
                    />
                  </Stack>
                  <Stack spacing={1}></Stack>
                  <div className="d-flex space-between mb-10">
                    <Button
                      variant="outlined"
                      className="mt-13  default-color default-border"
                      onClick={() => setStage(2)}
                      style={{ textTransform: "capitalize" }}
                    >
                      Back
                    </Button>

                    <Button
                      variant="contained"
                      className="mt-13 primary-button"
                      onClick={thirdStageHandler}
                      style={{ textTransform: "capitalize" }}
                    >
                      Next
                    </Button>
                  </div>
                </Stack>
              </Box>
            ) : stage == 4 ? (
              <Box>
                <Stack spacing={3} direction="column">
                  <h2 className="mt-13">Certifications</h2>
                  {certificationData.map((item, index) => (
                    <>
                      <Stack>
                        <Stack direction="row" justifyContent="space-between">
                          <Typography className="registration-label">
                            Certification Name
                          </Typography>
                          <Typography
                            style={{
                              cursor: "pointer",
                              color: "rgba(250, 131, 25, 1)",
                            }}
                            onClick={() => removeFormFields(index)}
                          >
                            Delete
                          </Typography>
                        </Stack>
                        {/* <TextField
                      required
                      id="outlined-basic"
                      variant="outlined"
                      className="w-100 "
                      size="small"
                      placeholder="Enter certification name"
                      value={certificationName}
                      onChange={(e) => setCertificationName(e.target.value)}
                    /> */}
                        {/* <FormControl fullWidth size="small">
                          <Select
                            displayEmpty
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={item.certificationName}
                            onChange={(e) =>
                              handleCertificationChange(
                                index,
                                "certificationName",
                                e.target.value
                              )
                            }
                            autoWidth
                          >
                            <MenuItem disabled value="">
                              <em>Select Certifications</em>
                            </MenuItem>
                            {certifications.map((item) => (
                              <MenuItem value={item.value}>
                                {item.label}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl> */}
                        <Autocomplete
                          disablePortal
                          id="combo-box-demo"
                          options={certifications}
                          onSelect={(e) =>
                            handleCertificationChange(
                              index,
                              "certificationName",
                              e.target.value
                            )
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Select Certifications"
                              // onChange={(e) =>
                              //   handleCertificationChange(
                              //     index,
                              //     "certificationName",
                              //     e.target.value
                              //   )
                              // }
                            />
                          )}
                        />
                      </Stack>

                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <Stack direction="row" spacing={6}>
                          <Stack>
                            <Typography className="registration-label">
                              Start Date
                            </Typography>
                            <DesktopDatePicker
                              size="small"
                              value={item.startDate}
                              minDate={new Date("2017-01-01")}
                              onChange={(newValue) =>
                                handleCertificationChange(
                                  index,
                                  "startDate",
                                  newValue
                                )
                              }
                              renderInput={(params) => (
                                <TextField {...params} />
                              )}
                            />
                          </Stack>
                          <Stack>
                            <Typography className="registration-label">
                              End Date
                            </Typography>
                            <DesktopDatePicker
                              value={item.endDate}
                              minDate={
                                item.startDate == ""
                                  ? new Date("2017-01-01")
                                  : item.startDate
                              }
                              onChange={(newValue) =>
                                handleCertificationChange(
                                  index,
                                  "endDate",
                                  newValue
                                )
                              }
                              renderInput={(params) => (
                                <TextField {...params} />
                              )}
                              disabled={item.startDate == "" ? true : false}
                            />
                          </Stack>
                        </Stack>
                      </LocalizationProvider>

                      <Stack>
                        <Typography className="registration-label">
                          Institute
                        </Typography>
                        <TextField
                          required
                          id="outlined-basic"
                          variant="outlined"
                          className="w-100 "
                          size="small"
                          placeholder="Enter institution Name"
                          value={item.institutionName}
                          onChange={(e) =>
                            handleCertificationChange(
                              index,
                              "institutionName",
                              e.target.value
                            )
                          }
                        />
                      </Stack>
                      <Stack>
                        <ImageUploader
                          passChildData={(data) =>
                            handleCertificationChange(
                              index,
                              "certificationImages",
                              data
                            )
                          }
                          heading="Upload Picture (Please upload picture of your certificate)"
                          title="Upload your certificate here"
                        />
                      </Stack>
                    </>
                  ))}

                  <Button
                    variant="outlined"
                    className="default-color w-43"
                    style={{ border: "1px dashed #0741c4" }}
                    onClick={addCertificateHandler}
                  >
                    + Add New Certificate
                  </Button>

                  <Stack>
                    <h2 className="mt-13">Documents</h2>
                  </Stack>
                  <Stack>
                    <ImageUploader
                      passChildData={photoIDChildDataHandler}
                      heading="Upload Photo ID"
                      title="Upload picture here"
                    />
                  </Stack>
                  <Stack>
                    <ImageUploader
                      passChildData={pofChildDataHandler}
                      heading="Upload Proof of Address"
                      title="Upload picture here"
                    />
                  </Stack>

                  <div className="d-flex space-between mb-10">
                    <Button
                      variant="outlined"
                      type="submit"
                      className="mt-13 default-border default-color"
                      onClick={() => setStage(3)}
                      style={{ textTransform: "capitalize" }}
                    >
                      Back
                    </Button>

                    {buttonLoading ? (
                      <Button
                        variant="contained"
                        className="mt-13 primary-button"
                        disabled
                      >
                        <CircularProgress
                          style={{ color: "white" }}
                          size={25}
                        />
                      </Button>
                    ) : (
                      <Button
                        variant="contained"
                        className="mt-13 primary-button"
                        onClick={fourthStageHandler}
                        style={{ textTransform: "capitalize" }}
                      >
                        Next
                      </Button>
                    )}
                  </div>
                </Stack>
              </Box>
            ) : stage == 5 ? (
              <Box>
                <Stack spacing={3} direction="column">
                  <h2 className="mt-13">Select Payment Method</h2>
                  <Stack direction={{ xs: "column", sm: "row" }}>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                      value={paymentMethod}
                      onChange={handlePaymentMethod}
                    >
                      <FormControlLabel
                        value="card"
                        control={<Radio />}
                        label="Debit or Credit Card"
                      />
                      <FormControlLabel
                        value="paypal"
                        control={<Radio />}
                        label="Paypal"
                      />
                    </RadioGroup>
                  </Stack>
                  <Stack>
                    <Typography className="registration-label">
                      Card Holder Name
                    </Typography>
                    <TextField
                      required
                      id="outlined-basic"
                      variant="outlined"
                      className="w-100 "
                      size="small"
                      placeholder="Enter card holder name"
                      value={cardHolderName}
                      onChange={(e) => setCardHolderName(e.target.value)}
                    />
                  </Stack>
                  <Stack>
                    <Typography className="registration-label">
                      Card Number
                    </Typography>
                    <TextField
                      required
                      id="outlined-basic"
                      variant="outlined"
                      className="w-100 "
                      size="small"
                      placeholder="Enter 16 digit number on your card"
                      value={cardNumber}
                      onChange={(e) => setCardNumber(e.target.value)}
                    />
                  </Stack>

                  <Stack direction="row" spacing={2}>
                    <Stack className="w-100 ">
                      <Typography className="registration-label">
                        Expiry
                      </Typography>
                      <TextField
                        required
                        id="outlined-basic"
                        variant="outlined"
                        size="small"
                        placeholder="MM/YY"
                        value={expiryDate}
                        onChange={(e) => setExpiryDate(e.target.value)}
                      />
                    </Stack>
                    <Stack className="w-100 ">
                      <Typography className="registration-label">
                        CVV
                      </Typography>
                      <TextField
                        required
                        id="outlined-basic"
                        variant="outlined"
                        size="small"
                        placeholder="Enter CVV"
                        value={securityCode}
                        onChange={(e) => setSecurityCode(e.target.value)}
                      />
                    </Stack>
                  </Stack>
                  <Stack>
                    <h2>Billing Address</h2>
                  </Stack>
                  <Stack direction="row" spacing={2}>
                    <Stack className="w-100 ">
                      <Typography className="registration-label">
                        Country
                      </Typography>
                      <TextField
                        required
                        id="outlined-basic"
                        variant="outlined"
                        size="small"
                        placeholder="Enter country"
                        value={country}
                        onChange={(e) => setCountry(e.target.value)}
                      />
                    </Stack>
                    <Stack className="w-100 ">
                      <Typography className="registration-label">
                        City
                      </Typography>
                      <TextField
                        required
                        id="outlined-basic"
                        variant="outlined"
                        size="small"
                        placeholder="Enter City"
                        value={city}
                        onChange={(e) => setCity(e.target.value)}
                      />
                    </Stack>
                  </Stack>

                  <Stack direction="row" spacing={2}>
                    <Stack className="w-100 ">
                      <Typography className="registration-label">
                        Door/House Number
                      </Typography>
                      <TextField
                        required
                        id="outlined-basic"
                        variant="outlined"
                        size="small"
                        placeholder="Enter your door or house number"
                        value={doorNumber}
                        onChange={(e) => setDoorNumber(e.target.value)}
                      />
                    </Stack>
                    <Stack className="w-100 ">
                      <Typography className="registration-label">
                        Street Address
                      </Typography>
                      <TextField
                        required
                        id="outlined-basic"
                        variant="outlined"
                        size="small"
                        placeholder="Enter street address"
                        value={streetAddress}
                        onChange={(e) => setStreetAddress(e.target.value)}
                      />
                    </Stack>
                  </Stack>
                  <Stack>
                    <Typography className="registration-label">
                      Zip or Postal Code
                    </Typography>
                    <TextField
                      required
                      id="outlined-basic"
                      variant="outlined"
                      size="small"
                      placeholder="Enter your zip or postal code"
                      value={postalCode}
                      style={{ width: "50%" }}
                      onChange={(e) => setPostalCode(e.target.value)}
                    />
                  </Stack>

                  <div className="d-flex space-between mb-10">
                    <Button
                      variant="outlined"
                      type="submit"
                      className="mt-13 default-border default-color"
                      onClick={() => setStage(4)}
                      style={{ textTransform: "capitalize" }}
                    >
                      Back
                    </Button>

                    <Button
                      variant="contained"
                      className="mt-13 primary-button"
                      onClick={submitServiceProviderInfo}
                      style={{ textTransform: "capitalize" }}
                    >
                      Submit
                    </Button>
                  </div>
                </Stack>
              </Box>
            ) : (
              <></>
            )}
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default ServiceProvider;
